import Quagga from 'quagga';

export function listenHardwareBarcode(callback) {
  let buffer = '';
  let timer;
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      if (buffer.length > 5) callback(buffer);
      buffer = '';
      clearTimeout(timer);
      return;
    }
    if (e.key.length === 1) {
      buffer += e.key;
      clearTimeout(timer);
      timer = setTimeout(() => { buffer = ''; }, 100);
    }
  });
}

export function initQuagga(target, onDetected) {
  Quagga.init({
    inputStream: { name: 'Live', type: 'LiveStream', target, constraints: { facingMode: 'environment' } },
    decoder: { readers: ['ean_reader', 'ean_8_reader', 'code_128_reader', 'code_39_reader'] }
  }, (err) => { if (!err) Quagga.start(); });
  Quagga.onDetected((data) => { if (data?.codeResult?.code) onDetected(data.codeResult.code); });
}

export function stopQuagga() { Quagga.stop(); }